import {schoolwork12} from "@tva/ng-migration/common/util";

export class CourseManagementConstants {
  static errors = {
    courseCode: {
      required: schoolwork12.app.manageCourseManagement.errorMessages.courseCodeRequired,
      duplicated: schoolwork12.app.manageCourseManagement.errorMessages.courseCodeDuplicated,
    },
    courseName: {
      required: schoolwork12.app.manageCourseManagement.errorMessages.courseNameRequired,
      MaxLength: schoolwork12.app.manageCourseManagement.errorMessages.courseNameMaxLength,
      duplicated: schoolwork12.app.manageCourseManagement.errorMessages.courseNameDuplicated
    },
    defaultCredits: {
      required: schoolwork12.app.manageCourseManagement.errorMessages.defaultCreditsRequired
    },
    courseGrade: {
      required: schoolwork12.app.manageCourseManagement.errorMessages.courseGradeRequired
    },
    courseType: {
      required: schoolwork12.app.manageCourseManagement.errorMessages.courseTypeRequired
    },
    daysPerWeek: {
      curricRequired: schoolwork12.app.manageCourseManagement.errorMessages.daysPerWeekRequired,
      daysPerWeekInvalidRange: schoolwork12.app.manageCourseManagement.errorMessages.daysPerWeekInvalidRange,
    },
    defaultAttendance: {
      curricRequired: schoolwork12.app.manageCourseManagement.errorMessages.defaultAttendanceRequired,
      defaultAttendanceMinutesInvalidRange: schoolwork12.app.manageCourseManagement.errorMessages.defaultAttendanceInvalidRange,
    },
    maxNumberPrepDays: {
      curricRequired: schoolwork12.app.manageCourseManagement.errorMessages.maxNumberPrepDaysRequired,
      maxNumberOfPrepDaysInvalidRange: schoolwork12.app.manageCourseManagement.errorMessages.maxNumberPrepInvalidValue,
    },
    coursePlatform: {
      curricRequired: schoolwork12.app.manageCourseManagement.errorMessages.coursePlatformRequired
    },
    contentProvider: {
      curricRequired: schoolwork12.app.manageCourseManagement.errorMessages.contentProviderRequired
    },
    abbreviation: {
      MaxLength: schoolwork12.app.manageCourseManagement.errorMessages.abbreviationMaxLength
    },
    nextCourses: {
      cleanRequired: schoolwork12.app.manageCourseManagement.errorMessages.nextCourseInvalidValue,
    },
  };

  static unsavedMessage = 'You have unsaved changes for the current screen. Do you want to continue without saving the course?'
}
